<template>
  <div class="upgrade-guide">
    <div class="guide-title">
      <span>周周领免单卡</span>
      <span class="icon-txt" @click="checkDetail">查看详情<i class="icon"></i></span>
    </div>
    <p class="guide-tip">下单升级会员，每周免费领取免单卡</p>
    <div class="guide-progress">
      <ul>
        <li class="v1-doc">
          <span class="t">V1</span>
        </li>
        <li class="v2-doc" :class="{'v-doc-active': userInfo.UserLevel >= 2}">
          <i class="iconfont icon-huangguan1"></i>
          <span class="t">V2</span>
          <span class="tip" :class="{'active': userInfo.UserLevel === 2}">每周1张</span>
        </li>
        <li class="v3-doc">
          <i class="iconfont icon-zuanshi"></i>
          <span class="t">V3</span>
          <span class="tip">每周2张</span>
        </li>
        <li class="progress">
          <div class="progress-active" :style="{width: activePosition}">
            <span class="doc"></span>
          </div>
          <span class="tooltip" :style="{left: activePosition}">
            <template v-if="userInfo.NeedBuyCount">还差{{userInfo.NeedBuyCount}}单</template>
            <template v-if="userInfo.NeedBuyCount && userInfo.NeedFriendCount">，</template>
            <template v-if="userInfo.NeedFriendCount">还差{{userInfo.NeedFriendCount}}位</template>
          </span>
        </li>
      </ul>
    </div>
    <div class="guide-btn" @click="upLevel">立即升级</div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    userInfo: {
      tyope: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    activePosition () {
      if (this.userInfo.UserLevel === 1) return '24.5%'
      else if (this.userInfo.UserLevel === 2) return '75%'
      else return 0
    }
  },
  methods: {
    checkDetail () {
      this.$emit('checkDetail')
    },
    upLevel () {
      this.$emit('upLevel')
    }
  }
}
</script>

<style scoped>
  .upgrade-guide{
    margin-top: 2%;
    background: #ffffff;
    padding:0 15px 10px;
    box-sizing: border-box;
    animation: opacityAnim 0.3s linear;
    animation-fill-mode: forwards;
  }
  .guide-title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
  }
  .guide-title > span:first-child{
    font-weight: 700;
    font-size: 17px;
  }
  .guide-title .icon-txt{
    color: #888;
    margin-right: 20px;
  }
  .guide-title .icon{ position: relative; }
  .guide-title .icon::after{
    content: "";
    border: solid 2px #c8c8cd;
    border-bottom-width: 0;
    border-left-width: 0;
    top: 50%;
    right: -16px;
    position: absolute;
    width: 5px;
    height: 5px;
    transform: translateY(-50%) rotate(45deg);
  }
  .guide-tip{
    color: #888;
    font-size: 12px;
  }
  .guide-btn{
    width: 60%;
    background: #ffffff;
    border: 1px solid;
    border-radius: 20px;
    height: 35px;
    line-height: 36px;
    text-align: center;
    margin: 0 auto;
  }
  .guide-btn:active{
    background: #f2f2f2;
  }
  /* progress */
  .guide-progress{
    margin: 0 0 10px;
    width: 100%;
  }
  .guide-progress ul{
    position: relative;
    display: flex;
    align-items: center;
    height: 110px;
    padding: 0 30px;
    box-sizing: border-box;
  }
  .guide-progress .doc{
    display: inline-block;
    width: 10px;
    height: 10px;
    border: 3px solid #ffffff;
    background: #D7B36E;
    border-radius: 50%;
  }
  [class*=-doc]{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border: 2px solid #e2e2e2;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    outline: 3px solid #ffffff;
    z-index: 10;
  }
  [class*=-doc] .t{
    position: absolute;
    top: 25px;
    font-weight: 600;
  }
  [class*=-doc] .tip{
    position: absolute;
    display: block;
    word-break: keep-all;
    top: 45px;
    left: -50%;
    font-size: 12px;
    color: #888;
  }
  .guide-progress .tip.active{
    color: #D7B36E;
  }
  .guide-progress .v1-doc{
    left: 20px;
    height: 10px;
    width: 10px;
    border: none;
    background: #D7B36E;
  }
  .v1-doc .t{
    top: 20px;
  }
  .guide-progress .v2-doc{
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .guide-progress .v3-doc{
    right: 20px;
  }
  .guide-progress .iconfont{
    font-size: 14px;
    color: #D7B36E;
  }
  .v2-doc .iconfont{
    font-size: 12px;
  }
  .guide-progress .v-doc-active{
    border-color: #D7B36E;
  }
  .v3-doc .iconfont{margin-top: 3px;}
  .guide-progress .progress{
    position: relative;
    width: 100%;
    height: 4px;
    background: #e2e2e2;
  }
  .progress .progress-active{
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 25%;
    background: #D7B36E;
    animation: proAnim 0.3s ease-in-out forwards;
  }
  .progress .doc{
    position: absolute;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
  }
  .progress .tooltip{
    position: absolute;
    left: 25%;
    transform: translateX(-50%);
    top: -34px;
    display: inline-block;
    word-break: keep-all;
    white-space: nowrap;
    background: #D7B36E;
    color: #ffffff;
    padding: 2px 6px;
    border-radius: 15px;
    font-size: 12px;
    box-shadow: 0 0 1px 1px #eed9b2;
    animation: possitionAnim 0.3s ease-in-out forwards;
  }
  .progress .tooltip::after{
    content: "";
    position: absolute;
    top: 19px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top-color: #D7B36E;
  }
  @media only screen and (device-width: 375px) and (device-height: 812px) {
    .v3-doc .iconfont{margin-top: 2px;}
    .progress .tooltip::after{
      top: 22px;
    }
  }
  @media only screen and (device-width: 414px) and (device-height: 896px) {
    .v3-doc .iconfont{margin-top: 2px;}
    .progress .tooltip::after{
      top: 22px;
    }
  }
  @keyframes proAnim {
    0%{width: 0;}
  }
  @keyframes possitionAnim {
    0%{left: 0;}
  }
</style>
